import { FunctionComponent } from 'react';
import './freetrial.scss';
import { S } from 'framer-motion/dist/types.d-6pKw1mTI';

export type Props = { borderColor?: string; lineColor?: string; fontColor?: string };

const OurFormula: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      style={{
        lineHeight: 1,
        maxWidth: '20rem',
        border: '3px dashed ' + (props.borderColor ?? 'white'),
        borderRadius: '1rem',
        padding: '1rem',
        color: props.fontColor ?? 'var(--RegularText)',
      }}
    >
      <div style={{ marginLeft: '1.5rem', fontSize: '1.25rem' }}>SPSS Statistics</div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
        <b style={{ fontSize: '1.5rem', width: '1.5rem' }}>+</b>
        <div style={{ marginTop: '0.25rem', fontSize: '1.25rem' }}>Predictive Solutions</div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderTop: '3px solid ' + (props.lineColor ?? 'white'),
          paddingTop: '0.25rem',
        }}
      >
        <b style={{ fontSize: '1.5rem', width: '1.5rem' }}>=</b>
        <div style={{ marginTop: '0.25rem', fontSize: '2rem' }}>
          <b>PS IMAGO</b> <b style={{ color: 'crimson' }}>PRO</b>
        </div>
      </div>
    </div>
  );
};

export default OurFormula;
